import React from 'react';
import { Instagram, Facebook } from 'lucide-react';

const SocialLinks = ({ size = "w-6 h-6", className = "" }) => {
  const socialLinks = [
    {
      name: "Instagram",
      url: "https://www.instagram.com/xkey.24",
      icon: Instagram,
      color: "hover:text-pink-500"
    },
    {
      name: "Facebook", 
      url: "https://www.facebook.com/people/XKey24/61581513321185/?mibextid=ZbWKwL",
      icon: Facebook,
      color: "hover:text-blue-600"
    },
    {
      name: "TikTok",
      url: "https://www.tiktok.com/@xkey24",
      icon: () => (
        <svg viewBox="0 0 24 24" className={size} fill="currentColor">
          <path d="M19.589 6.686a4.793 4.793 0 0 1-3.77-4.245V2h-3.445v13.672a2.896 2.896 0 0 1-2.909 2.909 2.896 2.896 0 0 1-2.909-2.909 2.896 2.896 0 0 1 2.909-2.909c.301 0 .587.041.855.119V9.44a6.336 6.336 0 0 0-.855-.057A6.364 6.364 0 0 0 3.1 15.748a6.364 6.364 0 0 0 6.364 6.364 6.364 6.364 0 0 0 6.364-6.364V7.598a8.156 8.156 0 0 0 4.761 1.527V5.68a4.793 4.793 0 0 1-1-.994z"/>
        </svg>
      ),
      color: "hover:text-black"
    }
  ];

  return (
    <div className={`flex items-center space-x-4 rtl:space-x-reverse ${className}`}>
      {socialLinks.map((social) => {
        const IconComponent = social.icon;
        return (
          <a
            key={social.name}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`text-gray-400 ${social.color} transition-colors duration-300 transform hover:scale-110`}
            aria-label={`Follow us on ${social.name}`}
          >
            <IconComponent className={size} />
          </a>
        );
      })}
    </div>
  );
};

export default SocialLinks;